export default __webpack_public_path__ + "static/O0256-b61d00fafce59e063af58848c6740e13.png";